export default __webpack_public_path__ + "static/media/SM.e180ec3e.svg";